import React from "react";
import { Select } from "antd";
import { monthOptions, yearOptions } from "../utils/dateUtils";

const { Option } = Select;

/**
 * Reusable Period Selector Component
 * Used throughout the app for selecting holding month and year
 */
const PeriodSelector = ({ 
  holdingMonth, 
  holdingYear, 
  onMonthChange, 
  onYearChange,
  className = "",
  style = {}
}) => {
  return (
    <div 
      className={`period-selector ${className}`} 
      style={{ display: "flex", gap: "10px", ...style }}
    >
      <Select 
        value={holdingMonth} 
        onChange={onMonthChange} 
        popupMatchSelectWidth={false}
        style={{ minWidth: 120 }}
      >
        {monthOptions.map((month) => (
          <Option key={month} value={month}>
            {month}
          </Option>
        ))}
      </Select>
      <Select 
        value={holdingYear} 
        onChange={onYearChange} 
        popupMatchSelectWidth={false}
        style={{ minWidth: 100 }}
      >
        {yearOptions.map((year) => (
          <Option key={year} value={year}>
            {year}
          </Option>
        ))}
      </Select>
    </div>
  );
};

export default PeriodSelector;

